"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CptCodeQuestion = require("./CptCodeQuestion");
Object.keys(_CptCodeQuestion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CptCodeQuestion[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CptCodeQuestion[key];
    }
  });
});